import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Service that provides an event bus for programmatically opening the My Account menu.
 * Used when callouts need to trigger menu opening (e.g., "Got it" button).
 */
@Injectable({
  providedIn: 'root',
})
export class NavatticMenuOpenService {
  /**
   * Subject that emits when the My Account menu should be opened.
   * Components can subscribe to this and call MatMenuTrigger.openMenu().
   */
  public readonly openMyAccountMenu$ = new Subject<void>();

  /**
   * Emits an event to open the My Account menu.
   * Call this when you want to programmatically open the menu (e.g., from a callout).
   */
  openMenu(): void {
    this.openMyAccountMenu$.next();
  }
}
